<div class="z-500 absolute top-2 right-2 flex flex-col justify-between h-screen">

  <div class=" flex flex-col">
    <mapm-icon [isActive]="isMapPanelVisible" tooltipText="{{'map.layers' | translate}}" containerClasses="rounded-t-md"
               icon="tk-i-map-layers-black" isActiveIcon="tk-i-map-layers-white" iconClasses="w-4 h-4"
               (click)="onSwitchMap()"></mapm-icon>

    <mapm-icon [isActive]="isShowPopupActive" tooltipText="{{'map.show-vehicles-names' | translate}}"
               iconClasses="w-4 h-3" icon="tk-i-vehicles-names-on" isActiveIcon="tk-i-vehicles-names-off"
               (click)="onShowPopups()"></mapm-icon>

    <mapm-icon [isActive]="isCenterMapActive" tooltipText="{{'map.center-map' | translate}}" iconClasses="w-4 h-3"
               icon="tk-i-show-all-vehicles-black" isActiveIcon="tk-i-show-all-vehicles-white"
               (click)="onCenterMap()"></mapm-icon>

    <mapm-icon [isActive]="isFullScreenActive" tooltipText="{{'map.full-screen-mode' | translate}}"
               icon="tk-i-fullscreen-black" isActiveIcon="tk-i-fullscreen-white"
               iconClasses="w-4 h-4" (click)="onToggleFullScreen()"></mapm-icon>

    <mapm-icon *ngIf="hasAccessToAreas" [isActive]="isAreasPanelActive" tooltipText="{{ 'labels.areas' | translate }}"
               containerClasses="rounded-b-md" icon="tk-i-areas-gray" isActiveIcon="tk-i-areas-white"
               iconClasses="w-4 h-4" (click)="onOpenAreasPanel()" id="map-icon-areas"></mapm-icon>
  </div>

  <div class="zoom-actions flex flex-col">
    <mapm-icon *ngIf="isTrackingVisible" class="mb-2" [isActive]="followVehicleStatus" [showToolTipOnActive]="true"
               tooltipText="{{'map.tracking-on' | translate}}" [showToolTipOnInactive]="true"
               inactiveTooltip="{{'map.tracking-off' | translate}}"
               containerClasses="rounded-md" icon="tk-i-tracking-blue" isActiveIcon="tk-i-tracking-black"
               iconClasses="w-4 h-4" (click)="onTracking()"></mapm-icon>

    <mapm-icon [isActiveOnHover]="true" [isTooltipVisible]="false"
               containerClasses="rounded-t-md" icon="tk-i-plus-black" isActiveIcon="tk-i-plus-white"
               iconClasses="w-4 h-4" (click)="onZoomIn()"></mapm-icon>

    <mapm-icon [isActiveOnHover]="true" [isTooltipVisible]="false"
               containerClasses="rounded-b-md" icon="bg-center tk-i-minus-black" isActiveIcon="bg-center tk-i-minus-white"
               iconClasses="w-4 h-4" (click)="onZoomOut()"></mapm-icon>
  </div>

</div>

<div class="z-500 absolute bottom-0 right-0 whitespace-nowrap flex">

  <span *ngIf="isEmapaSelected" class="flex bg-white px-1 mr-1 opacity-70">
    <a class="text-black" href="https://www.emapa.pl/" target="_blank">©Emapa</a>
  </span>

  <span *ngIf="isGoogleSelected" class="bg-white px-1 mr-1 text-center opacity-70">
    <a class="text-black" href="https://www.google.com/intl/pl_pl/help/terms_maps/" target="_blank">©Google</a>
  </span>

  <span *ngIf="isOpenStreetSelected" class="bg-white px-1 mr-1 text-center opacity-70">
    <a class="text-black" href="https://www.openstreetmap.org/copyright" target="_blank">©OpenStreetMap</a>
  </span>

  <span class="bg-white px-1">{{clientName}}</span>
</div>
